(function(e) {
    History.Adapter.bind(window,'statechange',function() {
        if (e(".product-listing").length > 0 || e(".filters-row").length > 0) {
            if(!obj.ajaxClickHandlerState) {
                var n = location.search == "" ? "" : "?" + location.search;
                var url = location.pathname + n;
                obj.getCollectionContent(url);
            }
            obj.ajaxClickHandlerState = false;
        }
    });

    var queryParams = {};
    var obj = {
        init: function() {
            queryParams = this.getQueryParams();
            this.initSidebar();
            this.initToolbar();
            this.initShowMore();
            this.initFilterPrice();
            this.currentFilter();
        },
        resetPriceFilter : function(){
            if($('.template-collection-section').length > 0 && $().slider ) {
                var end_slider = false;
                $( function() {
                    var range = $("#slider-range");
                    var money = range.data('range');
                    var mi = 1,ma = parseInt(money);
                    var cmin = mi,cmax = ma;
                    range.slider({
                        range: true,
                        min: mi,
                        max: ma,
                        values: [ cmin, cmax ],
                        slide: function( event, ui ) {
                            $( "#amount" ).val(money_format+ ui.values[ 0 ] + "-" + money_format + ui.values[ 1 ]).trigger('change');
                        }
                    });
                    $("#amount").val(money_format + $("#slider-range").slider("values", 0) + "-" + money_format + $("#slider-range").slider("values", 1));
                    var input_amount = $("#amount").val();
                    var fields = input_amount.split('-');
                    $('.amount-min').html(fields[0]);
                    $('.amount-max').html(fields[1]);
                });
            }
        },
        currentFilter : function(){
            var args = [];
            console.log(queryParams);
            $(window).load(function () {
                if (jQuery.isEmptyObject(queryParams)) {
                    $('a.clear_all').hide();
                }
            });

            if($('.template-collection-section').length > 0 && $().slider ) {
                var end_slider = false;
                $( function() {
                    var range = $("#slider-range");
                    var money = range.data('range');
                    var mi = 1,ma = parseInt(money);
                    var cmin = mi,cmax = ma;
                    if(typeof queryParams.price != typeof  undefined){
                        var data = queryParams.price.split('-');
                        cmin = parseInt(data[0].replace(money_format,''));
                        cmax = parseInt(data[1].replace(money_format,''));
                    }
                    range.slider({
                        range: true,
                        min: mi,
                        max: ma,
                        values: [ cmin, cmax ],
                        slide: function( event, ui ) {
                            $( "#amount" ).val(money_format+ ui.values[ 0 ] + "-" + money_format + ui.values[ 1 ]).trigger('change');
                        }
                    });
                    if(cmin != mi || cmax != ma){
                        $( "#amount" ).val(money_format +  $( "#slider-range" ).slider( "values", 0 ) + "-" + money_format + $( "#slider-range" ).slider( "values", 1 ) ).trigger('change');
                    }else{
                        $("#amount").val(money_format + $("#slider-range").slider("values", 0) + "-" + money_format + $("#slider-range").slider("values", 1));
                    }
                    var input_amount = $("#amount").val();
                    var fields = input_amount.split('-');
                    $('.amount-min').html(fields[0]);
                    $('.amount-max').html(fields[1]);
                    obj.ajaxClick(obj.getAjaxLink(queryParams));//when load url.
                });
                $('#amount').on('change',function(){
                    var val = $(this).val();
                    queryParams.price = val;
                    var fields = val.split('-');
                    $('.amount-min').html(fields[0]);
                    $('.amount-max').html(fields[1]);
                })
            }
        },
        initSidebar: function() {
            obj.initFiltresEvent();
            obj.initFiltresRemoveEvent();
        },
        initToolbar: function() {
            obj.initSortbyState();
            obj.initSortbyEvent();
            obj.initPerpageEvent();
            obj.initPaginationEvent();
        },
        initShowMore: function() {
            obj.initShowMoreEvent();
        },
        initFilterPrice: function() {
            obj.initFilterPriceEvent();
        },
        initShowMoreEvent: function() {
            if (e(".show-more a").length > 0) {
                e(".show-more>a").on('click',function(event) {
                    event.preventDefault();
                    e(this).children('i').addClass('loading');
                    if (!e(this).hasClass("disable")) {
                        event.preventDefault();
                        obj.showMoreHandler();
                    }
                })
            }
        },
        initFilterPriceEvent: function() {
            e(".go-filter-price >a").on('click',function(event) {
                event.preventDefault();
                obj.ajaxClick(obj.getAjaxLink(queryParams));
            })
        },
        showMoreHandler: function() {
            var scrollURL = e('.show-more a').last().attr("href");
            e.ajax({
                type: "GET",
                url: scrollURL,
                beforeSend: function() {
                    obj.showPreloader();
                },
                success: function(data) {
                    if (e(data).find(".product-view").length > 0) {
                        var show_more = '.show-more';
                        e(data).find(".product-view > div").each(function() {
                            e('.product-view').append(e(this));
                            var product_added = e(this).find('> div').length;
                            var product_current = e('.per-page').html();
                            var new_per_page = product_added + parseInt(product_current);
                            e('.per-page').html(new_per_page);
                        });
                        if(e(data).find('.show-more').length > 0){
                            e(show_more).html(e(data).find(show_more).html());
                        }else{
                            e(show_more).find('a').addClass('disable');
                            e(show_more).hide();
                        }
                        $('body').trigger('convert.money');
                        $('.show-more').children('i').removeClass('loading');
                        masonryReloadAjax();
                        obj.initShowMore();
                        //obj.init();
                        // if(e(".spr-badge").length > 0) {
                        //     e.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                        // }
                    }
                    data = null;
                },
                error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error1");
                },
                dataType: "html"
            })
        },
        initFiltresEvent: function() {
            if (e(".filters-js").length > 0) {
                e('.filters-js:not(.clear-filters) a').unbind().click(function(event) {
                    event.preventDefault();
                    delete queryParams.page;

                    var $_this = e(this);
                    var tag = $_this.attr('href').split('=').pop().split('?').shift();

                    var constraint = queryParams.constraint;
                    queryParams.constraint = constraint ? constraint+'+'+tag : tag;

                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            };
            if ($(".get-filter").length > 0) {
                var filters = $('.get-filter input:not(#amount)');
                filters.on('change',function(){
                    obj.getValue();
                });
            };
        },
        getValue : function(){
            var checked = $('.get-filter input');
            var query = [];
            checked.each(function(){
                query.push($(this).val());
            });
            queryParams.constraint = query.join('+');
            obj.ajaxClick(obj.getAjaxLink(queryParams));
        },
        initFiltresRemoveEvent: function() {
            if (e(".filters-remove-js").length > 0) {
                e('.filters-remove-js a').unbind().click(function(event) {
                    event.preventDefault();
                    delete queryParams.page;

                    var $_this = e(this);
                    if($_this.hasClass('clear_all')) {
                        delete queryParams.constraint;
                        delete queryParams.price;
                        obj.resetPriceFilter();
                    } else {
                        var href = $_this.attr('href');
                        var path = location.pathname;
                        var page = obj.getUrlSubcategory('/collections/', path);
                        var tag = href.split(page).pop().split('/').pop();
                        var arr = [];
                        var arr2 = queryParams.constraint.split('+');
                        $.each(arr2,function(i,e){
                            if(arr2[i] != tag){
                                arr.push(arr2[i]);
                            }
                        })
                        arr != '' ? queryParams.constraint = arr.join('+') : delete queryParams.constraint;
                    }
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            };
        },
        initSortbyState: function() {
            if (e(".sort-position").length > 0) {
                if (queryParams.sort_by) {
                    e('.sort-position').each(function() {
                        e(this).val(queryParams.sort_by);
                    });
                }
            }
        },
        initSortbyEvent: function() {
            if (e(".sort-position").length > 0) {
                e(document).find('.sort-position').change(function(event) {
                    var val = e(this).val();
                    queryParams.sort_by = val;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            }
        },
        initPerpageEvent: function () {
            if (e(".show-qty").length > 0) {
                e(document).find(".show-qty").change(function(event) {
                    var val = e(this).val();
                    if(e(this).find('option:selected').index() == 0) {
                        delete queryParams.view;
                    } else {
                        queryParams.view = val;
                    }
                    delete queryParams.page;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            }
        },
        initPaginationEvent: function() {
            if (e(".content-shop .pagination").length > 0) {
                e(".content-shop .pagination a").unbind().click(function(event) {
                    event.preventDefault();
                    if(!e(this).parent().hasClass("active")) {
                        var value = e(this).attr("href").match(/page=\d+/g);
                        if (!value) return false;
                        queryParams.page = parseInt(value[0].match(/\d+/g));
                        obj.ajaxClick(obj.getAjaxLink(queryParams));
                    }
                });
            };
        },
        getAjaxLink: function(value) {
            var page = obj.getUrlSubcategory('/collections/', location.pathname);
            var pathname = '/collections/' + page;
            value = obj.getDecodedUrl(value);
            return value != "" ? pathname + "?" + value : pathname;
        },
        //AJAX
        ajaxClick: function(url) {
            obj.ajaxClickHandlerState = true;
            History.pushState({
                param: Shopify.queryParams!='constraint='?Shopify.queryParams:''
            }, document.title, url);
            obj.getCollectionContent(url);
        },
        getCollectionContent: function(url) {
            var view = url.match(/view=([^&#]*)/);
            if (!view) {
                url += String(url.indexOf('?') > -1 ?'&':'?');
            } else {
                view = view[0];
                url = url.replace(view, view);
            }

            var params = {
                type: "get",
                url: url,
                beforeSend: function() {
                    obj.showPreloader();
                },
                success: function(data) {
                    obj.hidePreloader();
                    obj.pageData(data);
                    obj.initPaginationEvent();
                    obj.initSidebar();
                    obj.initShowMore();
                    masonryReloadAjax();
                    if (jQuery.isEmptyObject(queryParams)) {
                        $('a.clear_all').hide();
                    }else if(typeof queryParams.price != typeof  undefined){
                        var price = queryParams.price;
                        var item = "<li class='group'>Price</li><li class='padding'><a>" + price + "</a></li>";
                        $('li.no-filter').hide();
                        $('ul.filter-default').append(item);
                    }
                },
                error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error2")
                }
            }
            jQuery.ajax(params);
        },
        //Get and show new content
        pageData: function(data) {
            var pagination = ".nav-paginate";
            var product_view = ".show-products";
            var refine_box = ".refine-box";
            var filter_box = ".filter-box";
            var paginate_info = ".paginate-info";
            var show_more = ".show-more";

            e(pagination).empty();
            e(product_view).empty();
            e(refine_box).empty();
            e(filter_box).empty();
            e(paginate_info).empty();
            e(show_more).empty();
            //re-append html.
            e(pagination).html(e(data).find(pagination).html());
            e(product_view).html(e(data).find(product_view).html());
            e(refine_box).html(e(data).find(refine_box).html());
            e(filter_box).html(e(data).find(filter_box).html());
            e(paginate_info).html(e(data).find(paginate_info).html());
            e(show_more).html(e(data).find(show_more).html());
            obj.filterPrice();

            // if ($(document).find('.rating').length > 0){
            //     e.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            // }
        },
        filterPrice : function(){
            if(typeof queryParams.price != typeof undefined){
                var data = queryParams.price.split('-');
                var cmin = parseInt(data[0].replace(money_format,''));
                var cmax = parseInt(data[1].replace(money_format,''));
                $('.show-products .collection-product').each(function(){
                    var price =  parseInt($(this).find('.price-sale').html().replace('.00','').replace(money_format,''));
                    if(price < cmin || price > cmax){
                        $(this).remove();
                    }
                })
                $('.template-collection-section .pagination a').each(function(){
                    if($(this).attr('href') != undefined){
                        $(this).attr('href',$(this).attr('href')+'&price='+queryParams.price);
                    }
                })
            }
        },
        //Utils
        showPreloader: function() {
            e(".custom-loader").show();
        },
        hidePreloader: function() {
            e(".custom-loader").hide();
        },
        getUrlSubcategory: function (category, url) {
            var str = url;
            var n = str.indexOf(category);
            if(n < 0)
                return "";
            str = str.slice(n + category.length, str.length);
            var m = str.indexOf("/") > -1 ? str.indexOf("/") : str.length;
            str = str.slice(0, m).toLowerCase();
            return str.replace(name+"=", "");
        },
        getQueryParams: function() {
            var location_path = location.pathname;
            var location_search = location.search;
            var path_search = location_path.split('/');
            path_search.length > 3 ? path_search = 'constraint=' + path_search.pop().replace(/&/g, "") : path_search = location_search.split('?').pop();
            if(path_search == '') return {};
            else return obj.uriToJson(path_search);
        },
        uriToJson: function (value) {
            return JSON.parse('{"' + decodeURI(value.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}')
        },
        getDecodedUrl: function(value) {
            return decodeURIComponent($.param(value));
        }
    }
    e(document).ready(function() {
        obj.init();
    });
})(jQuery)